import { render, staticRenderFns } from "./CguCgv.vue?vue&type=template&id=22013bad&"
import script from "./CguCgv.vue?vue&type=script&lang=js&"
export * from "./CguCgv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports